import React, { useEffect, useState } from "react";
import { api } from "../lib/nurseryApi";
import { Printer, MegaphoneSimple, Leaf } from "@phosphor-icons/react";

export default function SalesKit() {
  const [kit, setKit] = useState(null);

  useEffect(() => {
    api.get("/sales-kit").then((r) => setKit(r.data));
  }, []);

  const print = () => window.print();

  if (!kit) return <div data-testid="sales-kit-page">Loading…</div>;

  const { outreach_script, pilot_offer, one_pager, competitor_gap } = kit;

  return (
    <div data-testid="sales-kit-page" className="fade-up">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 14, marginBottom: 28 }} className="no-print">
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--secondary)" }}>Door-to-door arsenal</div>
          <h1 className="page-title" style={{ marginTop: 8 }}>Sales Kit</h1>
          <p style={{ color: "var(--muted-fg)", marginTop: 8, fontSize: 14.5 }}>Everything you need to walk into a McMinnville nursery and close a field test today.</p>
        </div>
        <button className="btn btn-primary" onClick={print} data-testid="print-kit-btn"><Printer size={16} weight="bold" /> Print one-pager</button>
      </div>

      {/* One pager */}
      <section className="card" style={{ padding: 36 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--secondary)" }}>{one_pager.title}</div>
        <h2 className="font-display" style={{ fontSize: 40, marginTop: 10 }}>{one_pager.tagline}</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16, marginTop: 24 }}>
          {one_pager.problems_solved.map((p, i) => (
            <div key={i} style={{ background: "var(--bg-alt)", borderRadius: 16, padding: 20 }}>
              <div style={{ width: 38, height: 38, borderRadius: 12, background: "var(--primary-soft)", display: "grid", placeItems: "center", marginBottom: 10 }}>
                <Leaf size={18} weight="fill" color="var(--primary)" />
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--secondary)" }}>{p.name}</div>
              <div style={{ marginTop: 10, fontSize: 13.5, lineHeight: 1.55 }}><b>Before:</b> <span style={{ color: "var(--text-soft)" }}>{p.before}</span></div>
              <div style={{ marginTop: 6, fontSize: 13.5, lineHeight: 1.55 }}><b>With NurserySense:</b> <span style={{ color: "var(--text-soft)" }}>{p.after}</span></div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 24, padding: 22, background: "var(--text)", color: "rgba(255,255,255,0.9)", borderRadius: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--accent)" }}>Proof points</div>
          <ul style={{ marginTop: 10, paddingLeft: 22, lineHeight: 1.8, fontSize: 14.5 }}>
            {one_pager.proof_points.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
        </div>
      </section>

      {/* Pilot offer */}
      <section className="card" style={{ padding: 36, marginTop: 24, background: "linear-gradient(135deg, var(--secondary) 0%, #B26544 100%)", color: "white", border: "none" }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.9)" }}>{pilot_offer.headline}</div>
        <h2 className="font-display" style={{ fontSize: 36, marginTop: 8, color: "white" }}>{pilot_offer.title}</h2>
        <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 28, marginTop: 24 }} className="kit-grid">
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.9)" }}>What's included</div>
            <ul style={{ marginTop: 12, paddingLeft: 22, fontSize: 15, lineHeight: 1.7 }}>
              {pilot_offer.deliverables.map((d, i) => <li key={i}>{d}</li>)}
            </ul>
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.9)" }}>After-test pricing</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 12 }}>
              {(pilot_offer.after_pilot_pricing || []).map((p, i) => (
                <div key={i} style={{ borderRadius: 14, padding: "14px 16px", background: "rgba(255,255,255,0.18)" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontWeight: 700 }}>{p.plan}</div>
                    <div className="font-display" style={{ fontSize: 24 }}>${p.price_monthly}/mo</div>
                  </div>
                  <div style={{ fontSize: 12.5, marginTop: 4, opacity: 0.92 }}>{p.for}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Outreach script */}
      <section className="card" style={{ padding: 36, marginTop: 24 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--secondary)", display: "flex", alignItems: "center", gap: 8 }}>
          <MegaphoneSimple size={14} weight="fill" /> {outreach_script.title}
        </div>
        <h2 className="font-display" style={{ fontSize: 32, marginTop: 10 }}>What to say at the gate</h2>
        <div style={{ marginTop: 18, padding: 24, background: "var(--bg-alt)", borderRadius: 16 }}>
          {outreach_script.lines.map((l, i) => (
            <p key={i} style={{ fontSize: 15, lineHeight: 1.65, margin: "10px 0", color: "var(--text-soft)" }}>"{l}"</p>
          ))}
        </div>
        <div style={{ marginTop: 22 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--secondary)" }}>Common objections</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 12, marginTop: 12 }}>
            {outreach_script.objection_handlers.map((o, i) => (
              <div key={i} style={{ background: "var(--secondary-soft)", borderRadius: 14, padding: 16 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>"{o.objection}"</div>
                <div style={{ marginTop: 8, fontSize: 13.5, color: "var(--text-soft)", lineHeight: 1.55 }}>→ {o.answer}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Competitor gap */}
      <section className="card" style={{ padding: 36, marginTop: 24 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--secondary)" }}>{competitor_gap.title}</div>
        <h2 className="font-display" style={{ fontSize: 32, marginTop: 10 }}>Why nobody else is doing this</h2>
        <div style={{ marginTop: 18, overflowX: "auto" }}>
          <table className="soft-table">
            <thead><tr><th>Competitor</th><th>What they do</th><th>The gap</th></tr></thead>
            <tbody>
              {competitor_gap.rows.map((r, i) => (
                <tr key={i} style={r.name.includes("NurserySense") ? { background: "var(--primary-soft)" } : {}}>
                  <td><b style={r.name.includes("NurserySense") ? { color: "var(--primary)" } : {}}>{r.name}</b></td>
                  <td>{r.what_they_do}</td>
                  <td>{r.gap}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ marginTop: 20, padding: 18, background: "linear-gradient(135deg, var(--secondary) 0%, #B26544 100%)", color: "white", borderRadius: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.9)" }}>The moat</div>
          <p style={{ marginTop: 8, fontSize: 15, lineHeight: 1.6 }}>{competitor_gap.moat}</p>
        </div>
      </section>

      <style>{`
        @media print {
          .no-print, header, aside { display: none !important; }
          body, .organic-bg { background: white !important; }
        }
        @media (max-width: 900px) { .kit-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </div>
  );
}
